import {createContext, ReactNode, useContext} from "react"
import {isNotNullOrUndefined} from "~/utils/isNotNullOrUndefined"
import {Profile} from "~/.shared/profile/Profile"

const IsLoggedInContext = createContext<{
  isLoggedIn: boolean
  userId: null
  profile: null
} | {
  isLoggedIn: true
  userId: string
  profile: Profile
} | null>(null)

export const UserContextProvider = ({
  profile,
  children
}: {
  profile: Profile | null,
  children?: ReactNode
}) => {
  return (
    <IsLoggedInContext.Provider
      value={isNotNullOrUndefined(profile) ? {
        isLoggedIn: true,
        userId: profile.id,
        profile
      } : {
        isLoggedIn: false,
        userId: null,
        profile: null
      }}
    >
      {children}
    </IsLoggedInContext.Provider>
  )
}
export const useUserContext = () => {
  const context = useContext(IsLoggedInContext)
  if (!context) throw new Error("You can only use IsLoggedInContext within it's provider")
  return context
}